import axios from "axios";
import { apiUrl } from "../../constant";
import {
  getPackageAssignmentListService,
  approvePackageAssignmentService,
  rejectPackageAssignmentService,
  bulkApproveAssignmentsService,
  bulkRejectAssignmentsService,
  getPackageAssignmentByIdService,
  exportPackageAssignmentService,
  getPackageAssignmentHistoryService,
  getPackageAssignmentStatsService
} from "../../services/packageAssignment.service";

// Action types
export const GET_PACKAGE_ASSIGNMENT_LIST_REQUEST = 'GET_PACKAGE_ASSIGNMENT_LIST_REQUEST';
export const GET_PACKAGE_ASSIGNMENT_LIST_SUCCESS = 'GET_PACKAGE_ASSIGNMENT_LIST_SUCCESS';
export const GET_PACKAGE_ASSIGNMENT_LIST_FAILURE = 'GET_PACKAGE_ASSIGNMENT_LIST_FAILURE';

export const APPROVE_PACKAGE_ASSIGNMENT_REQUEST = 'APPROVE_PACKAGE_ASSIGNMENT_REQUEST';
export const APPROVE_PACKAGE_ASSIGNMENT_SUCCESS = 'APPROVE_PACKAGE_ASSIGNMENT_SUCCESS';
export const APPROVE_PACKAGE_ASSIGNMENT_FAILURE = 'APPROVE_PACKAGE_ASSIGNMENT_FAILURE';

export const REJECT_PACKAGE_ASSIGNMENT_REQUEST = 'REJECT_PACKAGE_ASSIGNMENT_REQUEST';
export const REJECT_PACKAGE_ASSIGNMENT_SUCCESS = 'REJECT_PACKAGE_ASSIGNMENT_SUCCESS';
export const REJECT_PACKAGE_ASSIGNMENT_FAILURE = 'REJECT_PACKAGE_ASSIGNMENT_FAILURE';

export const BULK_APPROVE_ASSIGNMENTS_REQUEST = 'BULK_APPROVE_ASSIGNMENTS_REQUEST';
export const BULK_APPROVE_ASSIGNMENTS_SUCCESS = 'BULK_APPROVE_ASSIGNMENTS_SUCCESS';
export const BULK_APPROVE_ASSIGNMENTS_FAILURE = 'BULK_APPROVE_ASSIGNMENTS_FAILURE';

export const BULK_REJECT_ASSIGNMENTS_REQUEST = 'BULK_REJECT_ASSIGNMENTS_REQUEST';
export const BULK_REJECT_ASSIGNMENTS_SUCCESS = 'BULK_REJECT_ASSIGNMENTS_SUCCESS';
export const BULK_REJECT_ASSIGNMENTS_FAILURE = 'BULK_REJECT_ASSIGNMENTS_FAILURE';

export const SET_PACKAGE_ASSIGNMENT_BACK_DETAILS = 'SET_PACKAGE_ASSIGNMENT_BACK_DETAILS';

// Action creators

// Get package assignment list
export const getPackageAssignmentList = (data) => async (dispatch) => {
  dispatch({ type: GET_PACKAGE_ASSIGNMENT_LIST_REQUEST });
  
  try {
    const response = await getPackageAssignmentListService(data);
    
    if (response?.data?.Status === 200) {
      dispatch({
        type: GET_PACKAGE_ASSIGNMENT_LIST_SUCCESS,
        payload: {
          list: response.data.EntityList || [],
          pageInfo: {
            TotalRecords: response.data.TotalRecords || 0,
            PageIndex: response.data.PageIndex || 1,
            PageSize: response.data.PageSize || 30
          }
        }
      });
    } else {
      dispatch({
        type: GET_PACKAGE_ASSIGNMENT_LIST_FAILURE,
        payload: response.data?.Entity || 'Failed to fetch package assignment list'
      });
    }
  } catch (error) {
    dispatch({
      type: GET_PACKAGE_ASSIGNMENT_LIST_FAILURE,
      payload: error.response?.data?.Entity || error.message || 'Network error'
    });
  }
};

// Approve package assignment
export const approvePackageAssignment = (packageId, comments) => async (dispatch) => {
  dispatch({ type: APPROVE_PACKAGE_ASSIGNMENT_REQUEST });
  
  try {
    const response = await approvePackageAssignmentService(packageId, comments);
    
    if (response?.data?.Status === 200) {
      dispatch({
        type: APPROVE_PACKAGE_ASSIGNMENT_SUCCESS,
        payload: response.data
      });
      return { success: true, data: response.data };
    } else {
      const errorMessage = response.data?.Entity || 'Failed to approve package assignment';
      dispatch({
        type: APPROVE_PACKAGE_ASSIGNMENT_FAILURE,
        payload: errorMessage
      });
      return { success: false, message: errorMessage };
    }
  } catch (error) {
    const errorMessage = error.response?.data?.Entity || error.message || 'Network error';
    dispatch({
      type: APPROVE_PACKAGE_ASSIGNMENT_FAILURE,
      payload: errorMessage
    });
    return { success: false, message: errorMessage };
  }
};

// Reject package assignment
export const rejectPackageAssignment = (packageId, comments) => async (dispatch) => {
  dispatch({ type: REJECT_PACKAGE_ASSIGNMENT_REQUEST });
  
  try {
    const response = await rejectPackageAssignmentService(packageId, comments);
    
    if (response?.data?.Status === 200) {
      dispatch({
        type: REJECT_PACKAGE_ASSIGNMENT_SUCCESS,
        payload: response.data
      });
      return { success: true, data: response.data };
    } else {
      const errorMessage = response.data?.Entity || 'Failed to reject package assignment';
      dispatch({
        type: REJECT_PACKAGE_ASSIGNMENT_FAILURE,
        payload: errorMessage
      });
      return { success: false, message: errorMessage };
    }
  } catch (error) {
    const errorMessage = error.response?.data?.Entity || error.message || 'Network error';
    dispatch({
      type: REJECT_PACKAGE_ASSIGNMENT_FAILURE,
      payload: errorMessage
    });
    return { success: false, message: errorMessage };
  }
};

// Bulk reject assignments
// Set back details for navigation
export const packageAssignmentBackDetails = (data) => (dispatch) => {
  dispatch({
    type: SET_PACKAGE_ASSIGNMENT_BACK_DETAILS,
    payload: data
  });
};

// Get package assignment by ID
export const getPackageAssignmentById = (id) => async (dispatch) => {
  try {
    const response = await getPackageAssignmentByIdService(id);
    return response.data;
  } catch (error) {
    console.error('Error fetching package assignment details:', error);
    throw error;
  }
};

// Export package assignments
export const exportPackageAssignments = (data) => async (dispatch) => {
  try {
    const response = await exportPackageAssignmentService(data);
    
    // Create blob and download file
    const blob = new Blob([response.data], { 
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `package-assignments-${new Date().getTime()}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return { success: true };
  } catch (error) {
    console.error('Error exporting package assignments:', error);
    return { success: false, message: error.message };
  }
};

// Get package assignment history
export const getPackageAssignmentHistory = (packageId) => async (dispatch) => {
  try {
    const response = await getPackageAssignmentHistoryService(packageId);
    return response.data;
  } catch (error) {
    console.error('Error fetching package assignment history:', error);
    throw error;
  }
};

// Get package assignment statistics
export const getPackageAssignmentStats = () => async (dispatch) => {
  try {
    const response = await getPackageAssignmentStatsService();
    return response.data;
  } catch (error) {
    console.error('Error fetching package assignment stats:', error);
    throw error;
  }
};

export const handleApproveRequest = (data) => {
    return axios.put(`${apiUrl}/api/IncomingPackage/UpdatePackagesForInvoicing`, data);
};